export default __webpack_public_path__ + "e15cf247aab358bcab517d751bb46d42.png";